import React from "react";

// MUI
import SvgIcon from '@mui/material/SvgIcon';

// Types
import { SvgIconProps } from "@mui/material";

function MuzejIcon(props: SvgIconProps) {
  return <SvgIcon {...props} >
    <svg version="1.1" id="MuzejIcon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      width="100px" height="100px" viewBox="0 0 100 100"
      style={{
        // @ts-ignore
        enableBackground: "new 0 0 100 100"
      }}
      xmlSpace="preserve">
      <polygon fill="#FFFFFF" points="83.8,42 83.8,28.6 75.1,28.6 50,14 24.9,28.6 16.2,28.6 16.2,42 19.5,42 19.5,71.5 16.2,71.5 
	16.2,84.3 83.8,84.3 83.8,71.5 80.5,71.5 80.5,42 "/>
      <g>
        <polygon fill="#3CAA78" points="48.1,72.2 36.8,72.2 36.8,69.1 39,69.1 39.7,44.5 38.9,43.3 37.6,43.3 37.6,41 47.2,41 47.2,43.3 
		45.9,43.3 45.1,44.5 45.8,69.1 48.1,69.1 	"/>
        <polygon fill="#3CAA78" points="32.9,72.2 21.6,72.2 21.6,69.1 23.8,69.1 24.6,44.5 23.7,43.3 22.4,43.3 22.4,41 32.1,41 
		32.1,43.3 30.8,43.3 30,44.5 30.7,69.1 32.9,69.1 	"/>
        <polygon fill="#3CAA78" points="63.2,72.2 51.9,72.2 51.9,69.1 54.1,69.1 54.9,44.5 54.1,43.3 52.8,43.3 52.8,41 62.4,41 
		62.4,43.3 61.1,43.3 60.3,44.5 61,69.1 63.2,69.1 	"/>
        <polygon fill="#3CAA78" points="78.4,72.2 67.1,72.2 67.1,69.1 69.3,69.1 70,44.5 69.2,43.3 67.9,43.3 67.9,41 77.6,41 77.6,43.3 
		76.3,43.3 75.4,44.5 76.2,69.1 78.4,69.1 	"/>
        <rect x="20" y="75.3" fill="#3CAA78" width="60" height="5.2" />
        <path fillRule="evenodd" clipRule="evenodd" fill="#3CAA78" d="M80,38.2H20v-5.7h5.9l24.1-14l24.1,14H80V38.2L80,38.2z
		 M62.9,32.5H37.1L50,25L62.9,32.5z"/>
      </g>
    </svg>
  </SvgIcon>
}

export default MuzejIcon;
